import apiHeader from '@/helpers/apiHeader';

const dataLogService = {
  list(params) {
    return apiHeader.get('report/data-log', { params });
  },
  get(id) {
    return apiHeader.get('report/data-log/' + id);
  },
  // Riwayat perubahan satu item MCR (emcr_items + tabel relasinya), terbaru dulu.
  getByEmcrItem(mcrItemCode) {
    return apiHeader.get('report/data-log/emcr-item/' + encodeURIComponent(mcrItemCode));
  },
  export() {
    return apiHeader.get(`report/data-log/export`, {
      responseType: 'blob',
    });
  },
};

export default dataLogService; 